import { useState, useCallback } from 'react';
import {
    createCompanyAdminCompanyPost,
    getCompanyAdminCompanyCompanyIdGet,
    updateCompanyAdminCompanyCompanyIdPut,
    CreateCompanyAdminCompanyPostData,
    GetCompanyAdminCompanyCompanyIdGetData,
    UpdateCompanyAdminCompanyCompanyIdPutData,
    signUpAuthSignupPost,
    SignUpAuthSignupPostData,
    VerifyEmailAuthVerifyEmailPostData,
    verifyEmailAuthVerifyEmailPost,
    SignInAuthLoginPostData,
    signInAuthLoginPost,
    logoutAuthLogoutPost,
} from "../client";

export const useAuth = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    // Auth related functions
    const signUp = useCallback(async (data: SignUpAuthSignupPostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await signUpAuthSignupPost(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const verifyEmail = useCallback(async (data: VerifyEmailAuthVerifyEmailPostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await verifyEmailAuthVerifyEmailPost(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const signIn = useCallback(async (data: SignInAuthLoginPostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await signInAuthLoginPost(data);
            return response;
        } catch (error: any) {
            if (error.response?.data) {
                const errorData = error.response.data;
                throw {
                    type: errorData.type,
                    message: errorData.message || '予期せぬエラーが発生しました',
                    status: error.response.status
                };
            }
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);



    const signOut = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await logoutAuthLogoutPost();
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        // State
        loading,
        error,

        // Auth functions
        signUp,
        verifyEmail,
        signIn,
        signOut
    };
};

export default useAuth;